// extracted by mini-css-extract-plugin
module.exports = {"container":"_5cf6161","football":"_7b67b89","tennis":"_cfa5aaa","basketball":"_b6c4c02","defaultStyle":"_96456db","children":"_fc868fa"};